import * as React from "react"
import { Grid } from "@mui/material"

import AdminNewListedRawTable from "./RawTable"
import AdminNewListedSkuMappingTable from "./SkuMappingTable"


export default function AdminNewListedContent() {
    return <Grid container spacing={2}>
        <Grid item xs={12}>
            <AdminNewListedRawTable />
        </Grid>

        <Grid item xs={12}>
            <AdminNewListedSkuMappingTable />
        </Grid>
    </Grid>
}